module.exports = __webpack_public_path__ + "static/media/gloria.1cb0f6e1.png";